import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonInboundMatchDetailsComponent } from 'src/app/modules/shared/common-inbound-match-details/common-inbound-match-details.component';
import { CommunicationInfoPopUpComponent } from 'src/app/modules/shared/communication-info-pop-up/communication-info-pop-up.component';
import { AlertService, CommonService, UserService } from 'src/app/services';
import { CommonStore } from 'src/app/store';
import { CommonUtil } from 'src/app/utils';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

    showHelpText: boolean = false;
    RxDrSt: any;
    maxScreenDetails: any;
    miniScreen: boolean[] = [];
    IsOutbondCall: boolean;
    miniScreenInbound: any;
    inboundDetails: any;
    value: string;
    updatecommsinfo: any;
    inboundMatchInfo: any;
    multiplePopups:NgbModalRef[] = [];
    multiplePopupsUpdateComms:NgbModalRef[] = [];
    callLogScreens: any = [];
    constructor(private _alertService: AlertService,private _commonServ:CommonService, private _modalService: NgbModal, private _commonStore:CommonStore, private _userServ: UserService, private _commonUtil: CommonUtil) { }

    ngOnInit() {
        this.value = this._commonUtil.commonLocationPath();
        this._alertService.getHelpText().subscribe(resp => {
            if (resp) {
                this.RxDrSt = resp;
                this.showHelpText = !this.showHelpText;
            } else {
                this.showHelpText = false;
            }
        });
        
        this._commonServ._miniMizeScreen$.subscribe(val => {
            if(val && val?.miniScreen) {
                this.callLogScreens.push(val);
                this.maxScreenDetails = val.details;
                this.miniScreen.push(val?.miniScreen);
                this.IsOutbondCall = this.maxScreenDetails?.logDetails?.callDetails?.direction === 'Outbound' ? true : false;
                if (this.multiplePopupsUpdateComms.length > 0 && !val?.miniScreen) {
                    this.inboundMatchInfo = this.multiplePopupsUpdateComms.pop();
                    this.inboundMatchInfo?.close();
                } else if(this.updatecommsinfo && !val?.miniScreen) {
                    this.updatecommsinfo?.close();
                }
            } else if(val && !val?.miniScreen) {
                const index = this.callLogScreens.findIndex((item: any) => { return (item?.details?.logDetails?.callDetails?.Identifier === val?.details?.logDetails?.callDetails?.Identifier) && (item?.details?.logDetails?.callDetails?.phoneNumber === val?.details?.logDetails?.callDetails?.phoneNumber) });
                if(index != -1) {
                    this.maxScreenDetails = this.callLogScreens[index]?.details;
                    this.miniScreen[index] = false;
                    this.callLogScreens.splice(index,1);
                    this.miniScreen.splice(index,1);
                }                
            }
        });

        this._commonStore._signlrInboundData$.subscribe(val => {
            if(val) {
                let ivrDetails = this._commonServ.getIvrGUIDDetails(this._commonServ.DecryptData(localStorage.getItem('SfaxEncryptionVector')));
                if(ivrDetails && (+ivrDetails?.extension === +val?.extension) && ivrDetails.isActive) {
                    this.inboundDetails = val;
                    if(this.inboundDetails?.call_state === "answered" && this.inboundDetails?.direction === 'inbound') {
                        this.value = this._commonUtil.commonLocationPath();
                        this.miniScreenInbound = true;
                    }
                }                
            }
        });

        this._commonServ._closeInboundPopup$.subscribe(val => {
                if(val && this.inboundMatchInfo) {
                    this._commonServ._closeInboundPopup$.next(null);
                    if (this.multiplePopups.length > 0) {
                    this.inboundMatchInfo = this.multiplePopups.pop();
                    this.inboundMatchInfo?.close();
                    } else if (this.inboundMatchInfo) {
                    this.inboundMatchInfo.close();
            }
                }
            });
    }

    closeHelpText() {
        this.showHelpText = false;
    }

    maxMizeScreen(screen) {
        const index = this.callLogScreens.findIndex((item: any) => { return item?.details?.logDetails?.callDetails?.Identifier === screen?.details?.logDetails?.callDetails?.Identifier });
        if(index != -1) {
            this.maxScreenDetails = this.callLogScreens[index]?.details;
            this.miniScreen[index] = false;
            this.callLogScreens.splice(index,1);
            this.miniScreen.splice(index,1);
        }
        this._commonServ._miniMizeScreen$.next(null);
        this.updatecommsinfo = this._modalService.open(CommunicationInfoPopUpComponent, { size: "md", backdrop: false, keyboard: true,
            windowClass: "medium-modal-50", centered: true });
            this.updatecommsinfo.componentInstance.UpdateCallLogDetails = this.maxScreenDetails;
            this.updatecommsinfo.componentInstance.IsMaxScreen = true;
            this.updatecommsinfo.componentInstance.IsfromManual = false;
            this.updatecommsinfo.componentInstance.IsOutbondCall = this.maxScreenDetails?.logDetails?.callDetails?.direction === 'Outbound' ? true : false;
            this.updatecommsinfo.componentInstance.CallLogDetails = this._commonServ.getIvrGUIDDetails(this._commonServ.DecryptData(localStorage.getItem('SfaxEncryptionVector')));
            this.updatecommsinfo.componentInstance.IsFrom = this.maxScreenDetails?.logDetails?.recipient?.entityType === 1 ? 'Patient' : this.maxScreenDetails?.logDetails?.recipient?.entityType === 2 ? 'Prescriber' : this.maxScreenDetails?.logDetails?.recipient?.entityType === 3 ? 'Insurance' : 'Pharmacy';
            this.updatecommsinfo.componentInstance.PatientDetails = this.maxScreenDetails?.logDetails?.patient;
            this.updatecommsinfo.componentInstance.PhoneNumber = this.maxScreenDetails?.logDetails?.callDetails?.phoneNumber;
            this.multiplePopupsUpdateComms.push(this.updatecommsinfo);
            this.updatecommsinfo.componentInstance.IsPopUpClosed.subscribe((resp) => {
            if (this.multiplePopupsUpdateComms.length > 0) {
                this.updatecommsinfo = this.multiplePopupsUpdateComms.pop();
                this.updatecommsinfo?.close();
            } else if (this.updatecommsinfo) {
                this.updatecommsinfo.close();
            }
            });
    }

    async getPatientFetchEntityList() {
        let phone = this.inboundDetails?.phone_number.replace("+1",'');
        this.miniScreenInbound = false;
        let res = await this._commonServ.getPatientFetchEntityList({phoneNumber:phone, npi:this._userServ.getToken("TenantId")}).toPromise();
        if(res) {
            this.inboundMatchInfo = this._modalService.open(CommonInboundMatchDetailsComponent, { size: "lg", backdrop: false, keyboard: true,
            windowClass: res?.entityDetails?.length ? "medium-modal-60" : "large--content", centered: true });
            this.inboundMatchInfo.componentInstance.MatchData = res;
            this.inboundMatchInfo.componentInstance.InboundDetails = this.inboundDetails;
            this.multiplePopups.push(this.inboundMatchInfo);
            this.inboundMatchInfo.componentInstance.IsPopUpClosed.subscribe((resp) => {
            if (this.multiplePopups.length > 0) {
                this.inboundMatchInfo = this.multiplePopups.pop();
                this.inboundMatchInfo?.close();
            } else if (this.inboundMatchInfo) {
                this.inboundMatchInfo.close();
            }
            });
        } else { this._commonServ._isCallOngoing$.next(null); }
    }

    saveInboundDetails() {
       this.miniScreenInbound = false;
       this._commonServ._storeCallLogDetailsForInbound$.next(this.inboundDetails);
    }

     ngAfterViewInit() {
        this.value = this._commonUtil.commonLocationPath();
    }
}
